import FetchService from "../FetchService/CustomService";
import { getErrorMessage } from "../utils";
import { getSalesContactNumber } from "../../utils/getSalesContactNumber";

const BaseUrl = process.env.BASE_URL;
const StaticUrl = process.env.STATIC_URL;

const MetaDataService = {
  async getMetadataVersion() {
    const url = BaseUrl + "/v2/metadata/version";
    const loaderConfig = { hasLoader: false };
    try {
      const res = await FetchService.getCall({
        url,
        loaderConfig
      });

      return res;
    } catch (error) {
      console.log("service error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async getCreditFaq() {
    const url = StaticUrl + "/api/recruiter/metadata/faqs";
    const loaderConfig = { hasLoader: false };
    try {
      // const res = await FetchService.getCall({
      //   url,
      //   loaderConfig
      // });

      const salesContactNumber = getSalesContactNumber();

      return {
        data: {
          heading: "Frequently Asked Questions",
          faqs: [
            {
              question: "What are Job Hai Credits? ",
              answer: `Job Hai Credits can be purchased on our platform and are used to post Premium Jobs, which enable you to hire faster.`
            },
            {
              question:
                "What are the types of job postings available on Job Hai?",
              answer: `Job Hai offers two main types of job postings:
                <p><div>1. <b>Premium Jobs</b>: These help you in <b>hiring faster</b> by offering several key benefits, such as: </div>
                <ul>
                <li>Boosted job visibility- Visibility of your job will be boosted on jobseekers’ job search page.</li>
                <li>High number of Direct Applies- More job seekers directly apply to your job.</li><li>High number of Database Matches- Get details of more candidates who match your job requirements.</li>
               <li> ‘Urgent Hiring’ tag- Highlight your job and increase your chances of a quick hire.</li>
               </ul>
               <div>2. <b>Basic Jobs:</b> These postings are a good way to get started with Job Hai and showcase your open positions. However, they come with some limitations, including low number of Direct Applies and Database Matches.</div>
               </p>
               `
            },
            {
              question:
                "I need to purchase Job Hai Credits in bulk. What should I do?",
              answer: `While our online platform currently allows for purchases of up to 5,000 Job Hai Credits at a time, we can help with larger needs!?To fulfil your bulk requirements contact our Sales Team at <b>${salesContactNumber} or email us at <a href="mailto:support@jobhai.com">support@jobhai.com</a></b>`
            },
            {
              question: "What is the validity of my Job Hai Credits?",
              answer: `The validity period of your Job Hai Credits is 30 days from the date they are purchased`
            },
            {
              question:
                "For how long will my Premium Job be active on Job hai??",
              answer:
                "All Premium Jobs remain active on Job Hai for <b>30</b> days from the date they are made active."
            }
          ]
        }
      };
    } catch (error) {
      console.log("service error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async getCreditInfo() {
    const salesContactNumber = getSalesContactNumber();
    const url = StaticUrl + "/api/recruiter/metadata/sales-contact";
    const loaderConfig = { hasLoader: false };
    try {
      // const res = await FetchService.getCall({
      //   url,
      //   loaderConfig
      // });

      return {
        data: {
          title: "Looking for something else?",
          subTitle: "Get a custom quote based on your needs!",
          contactNumber: salesContactNumber,
          workingTime:
            "(Working hours: 9:30 am to 6:30 pm , Monday to Saturday)",
          email: "sales@jobhai.com"
        }
      };
    } catch (error) {
      console.log("service error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async getCreditPrice() {
    const url = BaseUrl + "/recruiter/skus/v2/jobs-metadata";
    const loaderConfig = { hasLoader: false };
    try {
      const res = await FetchService.getCall({
        url,
        loaderConfig
      });
      return res.data.data;
    } catch (error) {
      console.log("service error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },
  async getCohortLimitData() {
    const url = BaseUrl + "/v2/metadata/job-posting-limit";
    const loaderConfig = { hasLoader: false };
    try {
      const res = await FetchService.getCall({
        url,
        loaderConfig
      });
      return res.data.data;
    } catch (error) {
      console.log("service error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async getRequisitionCategory() {
    const url = BaseUrl + "/v2/metadata/categories";
    const loaderConfig = { hasLoader: false };
    try {
      const res = await FetchService.getCall({
        url,
        loaderConfig
      });
      return res.data.data;
    } catch (error) {
      return Promise.reject(getErrorMessage(error));
    }
  }
};

export default MetaDataService;
